import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Loader, Header, Text } from '@pet-notify/ui'

import { useFoundPet } from 'hooks/found-pets'
import style from './style.module.css'
import { formatTimeString } from '@pet-notify/formatters'

function ConfirmationPage() {
  const { token } = useParams()
  const navigate = useNavigate()
  const foundPetQuery = useFoundPet(token)

  useEffect(() => {
    if (foundPetQuery.isError) {
      navigate('/found')
    }
  }, [foundPetQuery])

  if (foundPetQuery.isLoading || !foundPetQuery.data) {
    return <Loader />
  }

  const foundPet = foundPetQuery.data

  return (
    <>
      <Header as='h1' size='xlarge' mb='6'>
        Thanks {foundPet.name}, we are sending your contact information to{' '}
        {foundPet.pet.name}&apos;s parent now!
      </Header>

      <Text mb='12'>
        We&apos;ll also notify the pet parent&apos;s emergency contacts if they
        don&apos;t respond by{' '}
        {formatTimeString(foundPet.willNotifyEmergencyContactsAt)}
      </Text>

      <ul className={style.list}>
        <li className={style.calling}>Calling pet parent</li>
        <li className={style.emailing}>Emailing pet parent</li>
        <li className={style.texting}>Texting pet parent</li>
      </ul>

      <Header as='h2' size='large' mb='6'>
        Parent information
      </Header>

      <Text mb='6'>
        {foundPet.pet.user.name} - {foundPet.pet.user.phone}
      </Text>

      {foundPet.pet.meta.intellitagInstructions && (
        <>
          <Header as='h2' size='large' mb='6'>
            Special instructions
          </Header>
          <Text mb='6'>{foundPet.pet.meta.intellitagInstructions}</Text>
        </>
      )}
    </>
  )
}
export default ConfirmationPage
